var version = require('./application');
/*** Mode ***/
const _isLive = true;


module.exports = {
	mode : _isLive ? 'production' : 'development',
	version: version.version
};